import { render, staticRenderFns } from "./show_student_homework.vue?vue&type=template&id=1e642dfa&scoped=true"
import script from "./show_student_homework.vue?vue&type=script&lang=js"
export * from "./show_student_homework.vue?vue&type=script&lang=js"
import style0 from "./show_student_homework.vue?vue&type=style&index=0&id=1e642dfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e642dfa",
  null
  
)

export default component.exports